var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-none flex border-t border-gray-600"},_vm._l((_vm.weekDays),function(day,index){return _c('div',{key:day,staticClass:"flex-1 bg-gray-500 text-center text-xs font-medium uppercase tracking-wide text-white p-2",class:{
      'border-l': index,
      'border-gray-600': index,
    }},[_vm._v(" "+_vm._s(day)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }